/**
 * "A new version is ready": a phone can keep the app open for days, running the build it
 * loaded. Every few minutes (and on coming back to the app) the page is asked for again and
 * its app.js?v= compared with the one this page loaded. Only a reload swaps it: never in the
 * middle of something.
 */
import { useEffect, useState } from "react";
import { loadedBuild, servedBuild } from "./build-version.ts";

const EVERY_MS = 10 * 60_000;


export function NewVersionBanner() {
  const [ready, setReady] = useState(false);
  useEffect(() => {
    const mine = loadedBuild();
    if (!mine) return;
    let last = 0;
    const check = async () => {
      if (document.hidden || Date.now() - last < 60_000) return;
      last = Date.now();
      try {
        const html = await (await fetch(`/?build=${Date.now()}`, { cache: "no-store", headers: { accept: "text/html" } })).text();
        const now = servedBuild(html);
        if (now && now !== mine) setReady(true);
      } catch {
        /* no signal: ask again later */
      }
    };
    const t = setInterval(() => void check(), EVERY_MS);
    const onShow = () => document.visibilityState === "visible" && void check();
    document.addEventListener("visibilitychange", onShow);
    return () => {
      clearInterval(t);
      document.removeEventListener("visibilitychange", onShow);
    };
  }, []);
  if (!ready) return null;
  return (
    <div className="banner info" role="status" style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap" }}>
      <span style={{ flex: 1 }}>A new version of Think-Control is ready.</span>
      <button className="btn small" onClick={() => location.reload()}>
        Reload
      </button>
    </div>
  );
}
